import { render, staticRenderFns } from "./superlist.vue?vue&type=template&id=b6c591da&"
import script from "./superlist.vue?vue&type=script&lang=js&"
export * from "./superlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports